/* unplugin-vue-components disabled */import script from "./set-author-mobile-form.vue?vue&type=script&setup=true&lang=js"
export * from "./set-author-mobile-form.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__